export default {"src":"//a.static-global.com/metaf/metaf-web-user-center-ssr/_next/static/media/local.6fd69bf7.svg","height":66,"width":60};